import { ViewModel,View, ObservableArray, ViewModelMessage } from "binder"
import { SearchableSelectorBaseViewModel } from "src/common/reusableComponents/searchableSelectorBase/searchableSelectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import  { ProductSearchableSelectorView } from "./productSearchableSelector-view"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { CarBrandSelectorViewModel } from "src/Warehouse/carBrandManipulation/carBrandManipulation-viewModel";
import { CarModelSelectorViewModel } from "src/Warehouse/carModelManipulation/carModelManipulation-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";

export class ProductSearchableSelectorViewModel extends SearchableSelectorBaseViewModel<productForSelector>{
    private _shallShowBalancePopup:boolean;
    constructor(parentViewModel: ViewModel,shallShowBalancePopup:boolean, includeWrecked: boolean = true, showAdvancedSearch: boolean = false) {
    
        super(parentViewModel);
        this._shallShowBalancePopup = shallShowBalancePopup;
        this.includeWrecked = includeWrecked;
        this.showAdvancedSearch = showAdvancedSearch;
    }
    GetDefaultView(): View <ViewModel> {
        return new ProductSearchableSelectorView();
    }
    public getTypeId(): string {
        return "VM-82417A21-8A8A-4266-8214-F3612B05916A"
    }
    override scheduleSearch(){
     
    }

    public set includeWrecked(v: boolean) { this._includeWrecked = v; } public get includeWrecked(): boolean { return this._includeWrecked;} private _includeWrecked: boolean;
    public set carModelId(v: string) { this._carModelId = v; } public get carModelId(): string { return this._carModelId;} private _carModelId: string;
    public set carBrandId(v: string) { this._carBrandId = v; } public get carBrandId(): string { return this._carBrandId;} private _carBrandId: string;
    public set isAdvancedSearch(v: boolean) { this._isAdvancedSearch = v; } public get isAdvancedSearch(): boolean { return this._isAdvancedSearch;} private _isAdvancedSearch: boolean;
    public set showAdvancedSearch(v: boolean) { this._showAdvancedSearch = v; } public get showAdvancedSearch(): boolean { return this._showAdvancedSearch;} private _showAdvancedSearch: boolean;
    
    protected async loadData(searchedText: string): Promise<productForSelector[]> {
        let result = await ServerConnection.callServer('Complex/WarehouseServices/SearchProducts',{
            SearchText:searchedText,
            CarModelId: this.carModelId,
            IsAdvancedSearch: this.isAdvancedSearch,
            ResultCount: this.isAdvancedSearch ? 2000 : 100,
            IncludeWrecked: this.includeWrecked
        });
        return  result.Products.map(x=>this.convertSingle(x));
    }
    protected async loadById(id: string): Promise<productForSelector> {
        let result = await ServerConnection.callServer('Complex/WarehouseServices/SearchProductsById',{
            Id:id
        });    
        return this.convertSingle(result.Product);
    }
    async requestNew(){
        try {
            if (this.searchedText) {
                this.isLoading = true;
                let result = await ServerConnection.callServer('/Complex/WarehouseServices/CreateProductCreationRequest',{
                    ProvidedCode:this.searchedText
                });
                if (result.IsSuccessful == true) {
                    let message = `درخواست محصول جدید با کد ${this.searchedText} ایجاد شد.`;
                    await this.messageBoxConfirmSuccess(message,'عملیات موفق');
                    this.searchedText = '';
                } else {
                    throw 'خطا در انجام عملیات';
                }
            } else {
                throw 'باکس جستجو نمی تواند خالی باشد.'
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex,'خطا');
        } finally {
            this.isLoading = false;
        }
    }
    private convertSingle(dto:any):productForSelector{
        var p = new productForSelector(this);
        p.id = dto.Id;
        p.shallShowBalancePopup = this._shallShowBalancePopup;
        p.code = dto.ProductCode;
        p.productName = dto.ProductName;
        p.productBrand = dto.ProductBrand;
        p.title = `${dto.ProductCode} (${p.productName})`;
        p.brandColorAndCountry = dto.ColorBrandAndCountry;
        p.productCode = dto.PartNumber;
        p.productCarModel = dto.CarModel;
        p.hasCarModel = dto.HasCarModel;
        p.measuredProducts.update(...dto.MeasuredProducts.map(x=>{
            let y = new measuredProductDto(this);
            y.unitName = x.UnitName;
            y.unitId = x.UnitId;
            y.id = x.MeasuredProductId;
            return y;
        }));
        return p;
    }
    
    async advancedSearch() {
        let advancedSearch = new AdvancedSearch(this, this.carBrandId, this.carModelId);
        let message = new ShowAdvancedSearchPopupMessage(advancedSearch);
        this.handleMessage(message);
    
    }
    async clearAdvancedSearch(){
        this.isAdvancedSearch = false;
        this.carModelId = null;
        this.carBrandId = null;
    }
}

export class productForSelector extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);  
        this._isBalancesLoaded = false;
        this._isCarModelLoaded = false;
        this.measuredProducts = ObservableArray.create(); 
        this.balances = ObservableArray.create<SingleWarehouseBalance>();
        this.carModels = ObservableArray.create<CarModel>();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set pncName(v: string) { this._pncName = v; } public get pncName(): string { return this._pncName;} private _pncName: string;
    public set productName(v: string) { 
        this._productName = v.length > 11 ? v.substring(0, 10) + "..." : v;
    } public get productName(): string { return this._productName;} private _productName: string;
    public set productBrand(v: string) { this._productBrand = v; } public get productBrand(): string { return this._productBrand;} private _productBrand: string;
    public set measuredProducts(v: ObservableArray<measuredProductDto>) { this._measuredProducts = v; } public get measuredProducts(): ObservableArray<measuredProductDto> { return this._measuredProducts;} private _measuredProducts: ObservableArray<measuredProductDto>;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set brandColorAndCountry(v: string) { this._brandColorAndCountry = v; } public get brandColorAndCountry(): string { return this._brandColorAndCountry;} private _brandColorAndCountry: string;
    public set isLoadingBalances(v: boolean) { this._isLoadingBalances = v; } public get isLoadingBalances(): boolean { return this._isLoadingBalances;} private _isLoadingBalances: boolean;
    public set balances(v: ObservableArray<SingleWarehouseBalance>) { this._balances = v; } public get balances(): ObservableArray<SingleWarehouseBalance> { return this._balances;} private _balances: ObservableArray<SingleWarehouseBalance>;
    public set shallShowBalancePopup(v: boolean) { this._shallShowBalancePopup = v; } public get shallShowBalancePopup(): boolean { return this._shallShowBalancePopup;} private _shallShowBalancePopup: boolean;
    public set isLoadingCarModel(v: boolean) { this._isLoadingCarModel = v; } public get isLoadingCarModel(): boolean { return this._isLoadingCarModel;} private _isLoadingCarModel: boolean;
    public set carModels(v: ObservableArray<CarModel>) { this._carModels = v; } public get carModels(): ObservableArray<CarModel> { return this._carModels;} private _carModels: ObservableArray<CarModel>;
    public set hasCarModel(v: boolean) { this._hasCarModel = v; } public get hasCarModel(): boolean { return this._hasCarModel;} private _hasCarModel: boolean;
    private _isBalancesLoaded : boolean;
    private _isCarModelLoaded : boolean;

    public async popupShown(){
        if(this._isBalancesLoaded==true){
            return;
        }
        if(this.shallShowBalancePopup==false)
            return;
        try {
            this.isLoadingBalances = true;
            let result =await ServerConnection.callServer('/Complex/WarehouseServices/GetWarehouseBalancesForSingleProduct',{
                ProductId : this.id
            });
            this.balances.update(...result.Balances.map(x=>{
                let r = new SingleWarehouseBalance(this);
                r.warehouseName = x.WarehouseName;
                r.balance = x.Balance;
                r.accessibleBalance = x.AccessibleBalance;
                r.lockedNoSaleAmount = x.LockedNoSaleAmount;
                r.inSaleProcess = r.balance - r.accessibleBalance - r.lockedNoSaleAmount;
                return r;
            }))
            this._isBalancesLoaded = true;
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoadingBalances = false;
        }
    }

    public async ShowAllCarModels(){
        if(this._isCarModelLoaded==true){
            return;
        }
        try {
            this.isLoadingCarModel = true;
            let result =await ServerConnection.callServer('/Complex/WarehouseServices/GetAllCarModelsOfProduct',{
                ProductId : this.id
            });
            this.carModels.update(...result.CarModels.map(q=>{
                let r = new CarModel(this);
                r.fromYear = q.FromYear;
                r.toYear = q.UntilYear;
                r.carModelName = q.Name;
                r.carModelCode = q.Code;
                return r;
            }))
            this._isCarModelLoaded = true;
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoadingCarModel = false;
        }
    }
}

export class CarModel extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set carModelId(v: string) { this._carModelId = v; } public get carModelId(): string { return this._carModelId;} private _carModelId: string;
    public set carModelName(v: string) { this._carModelName = v; } public get carModelName(): string { return this._carModelName;} private _carModelName: string;
    public set carModelCode(v: string) { this._carModelCode = v; } public get carModelCode(): string { return this._carModelCode;} private _carModelCode: string;
    public set fromYear(v: number) { this._fromYear = v; } public get fromYear(): number { return this._fromYear;} private _fromYear: number;
    public set toYear(v: number) { this._toYear = v; } public get toYear(): number { return this._toYear;} private _toYear: number;
    
}

export class SingleWarehouseBalance extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance;} private _balance: number;
    public set accessibleBalance(v: number) { this._accessibleBalance = v; } public get accessibleBalance(): number { return this._accessibleBalance;} private _accessibleBalance: number;
    public set lockedNoSaleAmount(v: number) { this._lockedNoSaleAmount = v; } public get lockedNoSaleAmount(): number { return this._lockedNoSaleAmount;} private _lockedNoSaleAmount: number;
    public set inSaleProcess(v: number) { this._inSaleProcess = v; } public get inSaleProcess(): number { return this._inSaleProcess;} private _inSaleProcess: number;
}
export class measuredProductDto extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName;} private _unitName: string;
    public set unitId(v: string) { this._unitId = v; } public get unitId(): string { return this._unitId;} private _unitId: string;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    
}

export class AdvancedSearch extends ViewModel implements IPopup{
    public getTypeId(): string {return 'search';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:ProductSearchableSelectorViewModel, carBrandId:string, carModelId:string) {
        super(parent);
        this._parent = parent;
        this.carBrandSelector = new CarBrandSelectorViewModel(this, true);
        this.carBrandId = carBrandId;
        this.carModelId = carModelId;
        this.carBrandSelector.onSelectionChanged = q=>{
            this.carBrandId = q.id;
            this.carModelSelector = new CarModelSelectorViewModel(this, q.id);
            this.carModelSelector.refresh();
            this.carModelSelector.selectById(this.carModelId);
            this.carModelSelector.onSelectionChanged = p=>{
                this.carModelId = p.id;
                this.carModelName = p.title;
                this.isAdvancedSearch = true;
            }
        }
        this.carBrandSelector.selectById(this.carBrandId)
    }
    closePopup(resultCode: string = null) {
    }
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set carModelId(v: string) { this._carModelId = v; } public get carModelId(): string { return this._carModelId;} private _carModelId: string;
    public set carModelName(v: string) { this._carModelName = v; } public get carModelName(): string { return this._carModelName;} private _carModelName: string;
    public set carBrandId(v: string) { this._carBrandId = v; } public get carBrandId(): string { return this._carBrandId;} private _carBrandId: string;
    public set carBrandSelector(v: CarBrandSelectorViewModel) { this._partNumberSelector = v; } public get carBrandSelector(): CarBrandSelectorViewModel { return this._partNumberSelector;} private _partNumberSelector: CarBrandSelectorViewModel;
    public set carModelSelector(v: CarModelSelectorViewModel) { this._carModelSelector = v; } public get carModelSelector(): CarModelSelectorViewModel { return this._carModelSelector;} private _carModelSelector: CarModelSelectorViewModel;
    
    public set isAdvancedSearch(v: boolean) { this._isAdvancedSearch = v; } public get isAdvancedSearch(): boolean { return this._isAdvancedSearch;} private _isAdvancedSearch: boolean;

    private _parent : ProductSearchableSelectorViewModel;
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.carModelId)){
            result.push('مدل خودرو مشخص نشده است.')
        } 
        return result;
    }

    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'جستجوی پیشرفته');
                return;
            }
            this._parent.carModelId = this.carModelId;
            this._parent.carBrandId = this.carBrandId;
            this._parent.isAdvancedSearch = this.isAdvancedSearch;
            this.closePopup("done");
            setTimeout(() => {
                this._parent.refresh();    
            }, 100);
            
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
        }
    }

    back(){
        this.closePopup("");
    }
}

export class ShowAdvancedSearchPopupMessage extends ViewModelMessage{
    constructor(advancedSearch:IPopup) {
        super();
        this.advancedSearch = advancedSearch;
    }
    public advancedSearch:IPopup;

}
